import React from "react";
import { useDispatch, useSelector } from "react-redux";

import FormikContainer from "../../../../components/form/FormikContainer.jsx";
import { selectVehicleNumber } from "../../selectors.js";
import { setVehicleNumber } from "../../slice.js";
import { fetchMalfunctions } from "../../thunks.js";

import MalfunctionsList from "./MalfunctionsList.jsx";
import VehicleForm from "./VehicleForm.jsx";

const styles = {
  container: {
    marginTop: "30px",
  },
};

const Malfunctions = () => {
  const dispatch = useDispatch();

  const vehicleNumber = useSelector(selectVehicleNumber);

  const handleSubmit = async (values) => {
    dispatch(setVehicleNumber(values.vehicleNumber));
    await dispatch(fetchMalfunctions({ vehicleNumber: values.vehicleNumber }));
  };

  return (
    <div style={styles.container}>
      <FormikContainer
        initialValues={{ vehicleNumber }}
        onSubmit={handleSubmit}
        formComponent={VehicleForm}
      />
      <div style={styles.container}>
        <MalfunctionsList />
      </div>
    </div>
  );
};

export default Malfunctions;
